<template>
  <q-page-sticky
    :offset="[18, 18]"
    class="z-fab"
  >
    <q-btn
      type="submit"
      fab
      color="positive"
      icon="fa fa-check"
      @click="$emit('submit')"
    />
  </q-page-sticky>
</template>

<script>
export default {
  name: 'LwfFormSubmit'
}
</script>

<style scoped>

</style>
